import { logoIcon } from "../../icons"
import "./spinner.component.css"

const SpinnerComponent = () => {
  return (
    <div className="cb-spinner">
      <div className="cb-spinner-logo">{logoIcon}</div>
      <div className="cb-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
